import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/technological-transfer');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'technological-transfer',
  validationApi,
);

export function getTechnologicalTransferValidationHistoryOptions(
  technologicalTransferId: Id,
): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(technologicalTransferId);
}

export function getTechnologicalTransferValidationOptions(
  technologicalTransferId: Id,
): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(technologicalTransferId);
}

export function useValidateTechnologicalTransfer(technologicalTransferId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(technologicalTransferId, queryClient));
}
